// Configuration model for Carousel Office Add-in
import { DEFAULT_MODEL } from '../constants/models';
export class Config {
    constructor() {
        // General Settings
        this.isImageProcessingEnabled = false;
        this.isExcelInteractivityDisabled = true;
        this.canShowLevel0 = false;
        this.isSpeedMode = true;
        this.isSlideIndexingEnabled = true;
        this.isFullScanEnabled = false;
        this.doNotShowTrackChangesDialog = false;
        this.isPresetOn = true;
        this.autoFocusNewSheetOnCreate = true;
        // Excel Export Settings
        this.editMode = "clone"; // "clone" or "original"
        this.defaultBlackAndWhite = true;
        this.defaultCollapseGroups = false;
        this.defaultClearComments = true;
        // Excel Formatting Settings (semantic font colors during edit operations)
        this.isExcelSemanticFormattingEnabled = true;
        this.excelApplyColorsOnlyToEmptyCells = true;
        this.excelHardcodedFontColor = "#0000FF";
        this.excelCalculationFontColor = "#000000";
        this.excelReferenceOtherSheetFontColor = "#1E914E";
        this.excelReferenceOtherWorkbookFontColor = "#8B0000";
        this.excelReferenceExternalDataFontColor = "#E30000";
        // AI Model Settings
        this.carouselChatModel = DEFAULT_MODEL;
        this.carouselChatAgentModel = DEFAULT_MODEL;
        this.quickFixModel = DEFAULT_MODEL;
        this.carouselChatReasoning = "off";
        this.carouselChatAgentReasoning = "off";
        this.quickFixReasoning = "off";
        // AI Provider Settings - AWS Bedrock
        this.isAwsBedrockEnabled = false;
        this.awsApiKey = "";
        this.awsRegion = "us-east-1";
        // AI Provider Settings - Anthropic
        this.isAnthropicEnabled = false;
        this.anthropicApiKey = "";
        // AI Provider Settings - Azure Databricks
        this.isAzureDatabricksEnabled = false;
        this.databricksPATToken = "";
        this.databricksBaseUrl = "";
        // AI Provider Settings - Azure OpenAI
        this.isAzureOpenAIEnabled = false;
        this.azureOpenAIApiKey = "";
        this.azureOpenAIEndpoint = "";
        this.azureOpenAIApiVersion = "";
        // Integration Services
        this.isCapIQEnabled = false;
        this.isAlphaSenseEnabled = false;
        this.isTegusEnabled = false;
        // Constructor initializes default values (already done in field declarations)
    }
    // Export settings to JSON
    toExportableDto() {
        return {
            isExcelInteractivityDisabled: this.isExcelInteractivityDisabled,
            canShowLevel0: this.canShowLevel0,
            isSpeedMode: this.isSpeedMode,
            carouselChatModel: this.carouselChatModel,
            quickFixModel: this.quickFixModel,
            autoFocusNewSheetOnCreate: this.autoFocusNewSheetOnCreate,
        };
    }
    // Import settings from JSON
    fromExportableDto(dto) {
        this.isExcelInteractivityDisabled = dto.isExcelInteractivityDisabled;
        this.canShowLevel0 = dto.canShowLevel0;
        this.isSpeedMode = dto.isSpeedMode;
        this.carouselChatModel = dto.carouselChatModel;
        this.quickFixModel = dto.quickFixModel;
        this.autoFocusNewSheetOnCreate =
            typeof dto.autoFocusNewSheetOnCreate === "boolean"
                ? dto.autoFocusNewSheetOnCreate
                : true;
    }
}
